module.exports = __webpack_public_path__ + "static/media/Cesarienne.b51c7fdf.png";